"use client";

import { DeferredTooltipProvider } from "@/components/ui/deferred-tooltip-provider";
import { ReceiptsGrid } from "./components/receipts/receipts-grid";

export function AppPageClient() {
  return (
    <DeferredTooltipProvider delayDuration={0}>
      <ReceiptsGrid />
    </DeferredTooltipProvider>
  );
}
